import { Grid, TableCell, TableRow } from "@material-ui/core";
import { InputTextMaster, MasterButton, Modal } from "App/Component/ui";
import { DISABLED_BUTTON_SUBMIT } from "App/constants";
import React, { useState } from "react";
import { hapusPembelianTerkonfirmasi, headCellsTerproses, STATE_PEMBELIAN_TERPOSES } from "./helpers";
import {
  defaultToastError,
  defaultToastSuccess,
  formatNumber,
  formatRupiah,
  isNull,
} from "App/utils/helpers";
import { getComparator, stableSort } from "App/Component/ui/datatable/utils";
import { useDatatables } from "App/hooks";
import { Alert } from "@material-ui/lab";
import { FreezeTableClient } from "components/organism";
import DataCountPembelian from "./DataCountPembelian";
const btnLabel = {
  state: false,
  label: "Ya, hapus pembelian",
  color: "#0FB054",
};
function ModalKonfirmasiHapusPembelian({
  setShowModal,
  formData,
  setFormData,
  setNewData,
}) {
  const [disabled, setDisabled] = useState(btnLabel);

  const handleYes = async (e) => {
    setDisabled(DISABLED_BUTTON_SUBMIT);
    const res = await hapusPembelianTerkonfirmasi({
      id_pembelian: formData.id_pembelian,
      force: true
    });

    if (res.state) {
      defaultToastSuccess(res.message);
      setFormData(STATE_PEMBELIAN_TERPOSES);
      setNewData();
      setShowModal();
    } else {
      defaultToastError(res.message);
    }
    setDisabled(btnLabel);
  };

  const handleNo = async () => {
    setFormData(STATE_PEMBELIAN_TERPOSES);
    setShowModal();
  };

  const renderStatus = (row) => {
      if(row.inv_qty >= row.pemb_qty){
        return (
          <MasterButton
            style={{ borderRadius: 20 }}
            name={"VALID"}
            color={"green"}
            type='button'
            disabled
          />
        );
      }else if(row.inv_qty < row.pemb_qty){
        return (
          <MasterButton
            style={{ borderRadius: 20 }}
            name={"TIDAK VALID"}
            color={"danger"}
            type='button'
            disabled
          />
        );
      }else{
        return (
          <MasterButton
            style={{ borderRadius: 20 }}
            name={"!"}
            color={"secondary"}
            type='button'
            disabled
          />
        );
      }
  }

  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: formData.dataBarang,
    orderByDefault: "",
    orderByRow: ["nama_barang"],
  });
  return (
    <Modal
      title={`Apakah anda ingin menghapus pembelian ini?`}
      show={setShowModal}
      width='90%'>
      <Grid container spacing={3}>
        <Grid item sm={12}>
          <Grid container spacing={1}>
            <Grid item sm={3}>
              <InputTextMaster 
                id='id_pembelian'
                name='id_pembelian'
                label="ID PEMBELIAN"
                value={formData.id_pembelian}
                readOnly
              />
            </Grid>
            <Grid item sm={3}>
              <InputTextMaster 
                id='no_faktur'
                name='no_faktur'
                label="NOMOR FAKTUR"
                value={formData.no_faktur}
                readOnly
              />
            </Grid>
            <Grid item sm={3}>
              <InputTextMaster 
                id='gudang'
                name='gudang'
                label="GUDANG"
                value={formData.gudang}
                readOnly
              />
            </Grid>
            <Grid item sm={3}>
              <InputTextMaster 
                id='supplier'
                name='supplier'
                label="SUPPLIER"
                value={formData.supplier}
                readOnly
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item sm={12}>
        <DataCountPembelian formData={formData} />
        </Grid>
        <Grid item sm={12}>
          <FreezeTableClient
            isFreeze={false}
            trTopChild="61px"
            title={`DAFTAR ITEM PEMBELIAN`}
            setQ={setQ}
            maxHeight='300px'
            withAddButton={false}
            withExportButton={false}
            order={order}
            orderBy={orderBy}
            handleRequestSort={handleRequestSort}
            length={length}
            rows={formData.dataBarang}
            headCells={headCellsTerproses}
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            headCellsLength={18}
            setRowsPerPage={setRowsPerPage}>
            {stableSort(data, getComparator(order, orderBy))
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                const hppAkhir = row?.rs_qty-row?.pemb_qty === 0 ? 0 : (row.rs_persediaan-row.pemb_persediaan)/(row?.rs_qty-row?.pemb_qty);
                return (
                  <TableRow
                    hover
                    tabIndex={-1}
                    key={index}
                    >
                    <TableCell scope='row' padding='none' align='center'>
                      {index + 1}
                    </TableCell>
                    <TableCell align='left'>{renderStatus(row)}</TableCell>

                    <TableCell align='left'>{row.id_barang}</TableCell>
                    <TableCell align='left'>{row.nama_barang}</TableCell>
                    <TableCell align='right'>{formatNumber(row.rs_qty)}</TableCell>
                    <TableCell align='right'>{formatRupiah(row.rs_persediaan)}</TableCell>

                    <TableCell align='right'>{formatNumber(row.pemb_qty)}</TableCell>
                    <TableCell align='right'>{formatRupiah(row.pemb_harga_per_qty)}</TableCell>
                    <TableCell align='right'>{formatRupiah(row.pemb_persediaan)}</TableCell>

                    <TableCell align='right'>{formatNumber(row.inv_qty)}</TableCell>
                    <TableCell align='right'>{formatRupiah(row.inv_hargapokok)}</TableCell>
                    <TableCell align='right'>{formatRupiah(row.inv_persediaan)}</TableCell>

                    <TableCell align='right'>{formatNumber(row.inv_qty_akhir)}</TableCell>
                    <TableCell align='right'>{formatRupiah(hppAkhir)}</TableCell>
                    <TableCell align='right'>{formatRupiah(row.inv_qty_akhir*hppAkhir)}</TableCell>

                    <TableCell align='right'>{formatNumber(row.rs_qty-row.pemb_qty)}</TableCell>
                    <TableCell align='right'>{formatRupiah(hppAkhir)}</TableCell>
                    <TableCell align='right'>{formatRupiah((row.rs_qty-row.pemb_qty)*hppAkhir)}</TableCell>

                  </TableRow>
                );
              })}
          </FreezeTableClient>
        </Grid>
        <Grid item md={12}>
          <Alert severity='info' variant='outlined' style={{ width: "100%" }}>
           {`Syarat penghapusan pembelian :
            1. Tidak ada pembayaran,
            2. Jumlah item valid minimal 1,
            3. Jumlah item tidak valid 0,
            *periksa kembali qty pembelian apakah lebih kecil dari qty inventory`}
          </Alert>
        </Grid>
      </Grid>
      <Grid
        container
        direction='row'
        justifyContent='flex-end'
        alignItems='center'>
        <MasterButton
          color='danger'
          className={"mr-1 mt-1"}
          size='lg'
          outline={true}
          name='Batal'
          onClick={(e) => handleNo(e)}
        />
        <MasterButton
          className={"mr-1 mt-1"}
          color={formData.valid_data > 0 && formData.unvalid_data === 0 && formData.total_pembayaran === 0 ?  disabled.color : "secondary"}
          size='lg'
          onClick={(e) => formData.valid_data > 0 && formData.unvalid_data === 0 && formData.total_pembayaran === 0 ?  handleYes(e) : null}
          name={disabled.label}
          disabled={formData.valid_data > 0 && formData.unvalid_data === 0 && formData.total_pembayaran === 0 ? disabled.state : true}
        />
      </Grid>
    </Modal>
  );
}

export default ModalKonfirmasiHapusPembelian;
